import commonFn from '@/commons/commonFunction';

import _ from 'lodash';
export default class {
  constructor(name, api) {
    const me = this;
    /**
     * state
     */
    me.state = {
      /**
       * Cấu hình của module
       */
      _config: {
        field: {}
      },
      /**
       * loading
       */
      loading: false,
      /**
       * loading load summary
       */
      loadingSummary: false,
      /**
       * Tổng bản ghi theo paging
       */
      total: 0,
      /**
       * Thông tin tổng
       */
      summary: null,
      /**
       * active data - dùng cho combobox
       */
      items: [],
      /**
       * Không có dữ liệu trong bảng
       * Dùng cờ này để hiển thị mặc hình trống trên danh sách
       */
      empty: false,
      /**
       * Danh sách các cache key sẽ phải xóa đi khi có cập nhật dữ liệu
       */
      cacheKeys: [],
      /**
       * Version dữ liệu ở client để đánh dấu là có thay đổi -> dựa theo món này thay đổi để load lại dữ liệu của combobox
       */
      version: 1
    };

    /**
     * actions
     */
    me.actions = {
      /**
       * Lấy đường dẫn controller api
       */
      getController() {
        return api.getAPIUrl();
      },

      /**
       * Load danh sách
       */
      async load(context, payload) {
        let res = null;
        try {
          context.commit('updateLoading', true);
          res = await api.getList(payload || {});
        } finally {
          context.commit('updateLoading', false);
        }

        if (res) {
          context.commit('setPaging', res);
        }

        return res;
      },

      /**
       * Load danh sách
       */
      async loadSummary(context, payload) {
        let res = null;
        try {
          context.commit('updateLoadingSummary', true);
          res = await api.getListSummary(payload || {});
        } finally {
          context.commit('updateLoadingSummary', false);
        }

        if (res) {
          context.commit('setPaging', res);
        }

        return res;
      },

      /**
       * Load tree
       */
      async loadTree(context, payload) {
        let res = null;

        try {
          context.commit('updateLoading', true);
          res = await api.getTree(payload || {});
        } finally {
          context.commit('updateLoading', false);
        }

        if (res) {
          context.commit('setItems', res);
        }

        return res;
      },

      /**
       * Load full data
       */
      async getFullList(context, payload) {
        context.commit('updateLoading', true);

        let res = await api.getFullList(payload || {});
        context.commit('updateLoading', false);

        if (res) {
          context.commit('setItems', res);
        }

        return res;
      },

      /**
       * Lấy danh sách dữ liệu theo id
       */
      async getDataByIds(context, payload) {
        return await api.getDataByIds(payload || {});
      },

      /**
       * clearItem
       * @param {*} context
       */
      clearItem(context) {
        context.commit('setItems', []);
      },

      /**
       * Lấy mã tự tăng
       */
      async getAutoID(context, payload) {
        //context.commit("updateLoading", true);

        let res = await api.getAutoID();
        //context.commit("updateLoading", false);

        return res;
      },

      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async get(context, payload) {
        let method = 'get' + payload.action;
        delete payload.action;

        let res = await api[method](payload);
        return res;
      },
      /**
       * Thêm mới
       */

      async insert(context, payload) {
        let res = await api.insert(payload);
        if (res) {
          //cập nhật danh sách
          context.commit('insertItem', res);
        }
        return res;
      },
      /**
       * Cập nhật
       */ async update(context, payload) {
        let res = await api.update(payload);
        if (res) {
          //cập nhật danh sách
          context.commit('updateItem', res);
        }
        return res;
      },
      /**
       * Xóa
       */
      async delete(context, payload) {
        let res = await api.delete(payload);
        let pasValidate = ['GENERATE_DATA'];
        //cập nhật danh sách
        let deleted = [];
        if (res) {
          for (let i = 0; i < payload.Models.length; i++) {
            if (
              res.hasOwnProperty(String(i)) &&
              !pasValidate.find(x => x === res[i]?.Code)
            ) {
              continue;
            }

            deleted.push(payload.Models[i]);
          }
        }
        context.commit('deleteItems', deleted);
        return res;
      }
    };

    /**
     * mutations
     */
    let defaultState = {};
    Object.assign(defaultState, me.state);
    me.mutations = {
      resetState(state) {
        Object.assign(state, defaultState);
      },
      setItems(state, data) {
        state.items = data;
      },
      setPaging(state, data) {
        if (data) {
          for (let i in data) {
            let resultValue = data[i];
            switch (i) {
              case 'Data':
                state.items = resultValue;
                break;
              case 'Total':
                state.total = resultValue;
                break;
              case 'Empty':
                state.empty = resultValue;
                break;
              case 'SummaryData': {
                state.summary = resultValue;
                break;
              }
            }
          }
        }
      },
      addNew(state, item) {
        state.items.push(item);
      },
      updateLoading(state, data) {
        state.loading = data;
      },
      updateLoadingSummary(state, data) {
        state.loadingSummary = data;
      },
      setItem(state, data) {
        state.item = data;
      },
      /**
       * Cập nhật khi thêm bản ghi
       */ insertItem(state, data) {
        let newItem = data;
        state.items = _.concat(newItem, state.items);
        state.total += 1;
        state.empty = false;

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },
      /**
       * Cập nhật khi sửa bản ghi
       */

      updateItem(state, data) {
        let keyField = state._config.field.key;

        if (keyField) {
          let id = data[keyField];
          for (let i = 0; i < state.items.length; i++) {
            let item = state.items[i];

            if (item[keyField] === id) {
              //Check xem nếu có thay đổi ở cấu trúc tree thì thì assign lại data để thực hiện build lại cấu trúc
              //NCPHUOC 08/07/2022
              if (
                item.hasOwnProperty('parent_id') &&
                item['parent_id'] !== data['parent_id']
              ) {
                Object.assign(item, data);
                state.items = [...state.items];
              } else {
                Object.assign(item, data);
              }
              break;
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },
      /**
       * Cập nhật khi sửa bản ghi
       * NXCHIEN 07.06.2022
       */
      updateItemQuickFllow(state, payload) {
        let quickField = state._config.field.quickFollow,
          keyField = state._config.field.key,
          data = payload.data,
          value = payload.value;

        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && quickField) {
              let id = data[i];
              let objValue = {};
              objValue[quickField] = value;

              for (let j = 0; j < state.items.length; j++) {
                let item = state.items[j];

                if (item[keyField] === id) {
                  Object.assign(item, objValue);
                  // break;
                }
              }
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },
      /**
       * Cập nhật khi sửa bản ghi ghi sổ
       * NNLINH 15.07.2022
       */
      updateItemPosted(state, payload) {
        let postedField = state._config.field.posted,
          keyField = state._config.field.key,
          data = payload.data,
          value = payload.value;
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && postedField) {
              let id = data[i];
              let objValue = {};
              objValue[postedField] = value;

              for (let j = 0; j < state.items.length; j++) {
                let item = state.items[j];

                if (item[keyField] === id?.refId) {
                  Object.assign(item, objValue);
                  // break;
                }
              }
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật khi sửa bản ghi ghi sổ cho cam kết chi
       * HQMINH 20.07.2022
       */
      updateChangeMutilItemPosted(state, payload) {
        let postedField = state._config.field.posted,
          keyField = state._config.field.key,
          data = payload.data[0];
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (keyField && postedField) {
              let id = data[i];
              let value = data[i].is_posted;
              let objValue = {};
              objValue[postedField] = value;

              for (let j = 0; j < state.items.length; j++) {
                let item = state.items[j];

                if (item[keyField] === id?.refId) {
                  Object.assign(item, objValue);
                  // break;
                }
              }
            }
          }
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      },

      /**
       * Cập nhật khi xóa bản ghi
       */ deleteItems(state, items) {
        let keyField = state._config.field.key;

        if (keyField) {
          let count = items.length;
          let newList = [];
          for (let i = 0; i < state.items.length; i++) {
            let item = state.items[i],
              ignore = false;
            for (let k = 0; k < count; k++) {
              let id = items[k][keyField];

              if (item[keyField] === id) {
                ignore = true;
                break;
              }
            }

            if (!ignore) {
              newList.push(item);
            }
          }

          state.items = newList;
          state.total -= count;
        }

        //xóa cache combobox data
        if (state.cacheKeys) {
          commonFn.removeCacheComboboxData(state.cacheKeys);
        }
        state.version++;
      }
    };

    /**
     * getters
     */
    me.getters = {};
    for (let i in me.state) {
      me.getters[i] = function(state) {
        return state[i];
      };
    }
  }
}
